import React from 'react';
import { Globe } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

const LanguageSelector = ({ variant = 'default' }) => {
  const { language, changeLanguage } = useLanguage();
  const currentLang = languages.find(l => l.code === language) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          data-testid="language-selector-btn"
          variant={variant === 'outline' ? 'outline' : 'ghost'} 
          size="sm"
          className="gap-2 text-black border-emerald-600 hover:bg-emerald-50"
        >
          <Globe size={18} weight="duotone" className="text-emerald-700" />
          <span className="hidden sm:inline font-semibold">{currentLang.flag} {currentLang.code.toUpperCase()}</span>
          <span className="sm:hidden">{currentLang.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`language-option-${lang.code}`}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer ${language === lang.code ? 'bg-emerald-50 text-emerald-900 font-semibold' : ''}`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;